import debounce from "debounce-promise";
import { plainToInstance } from "class-transformer";
import { EpicSearchResultsWithCursorDto } from "healthex-common/epic.directory.dtos";
import { FeatureFlag } from "healthex-common/features.dtos";
const emptyResults = () => plainToInstance(EpicSearchResultsWithCursorDto, { results: [], nextCursor: null, totalHits: 0 });
function typeLabel(result) {
    var _a;
    return ((_a = result.careFacilityName) === null || _a === void 0 ? void 0 : _a.trim()) ? "CF" : "PB";
}
export class EpicSearchManager {
    constructor(epicDirectoryService, authManager, featureManager) {
        this.epicDirectoryService = epicDirectoryService;
        this.authManager = authManager;
        this.featureManager = featureManager;
        this.search = debounce(async (query, filters, cursor) => {
            try {
                const isSandbox = this.authManager.isSandbox;
                const response = await this.epicDirectoryService.search(query, isSandbox, cursor, filters);
                const config = this.featureManager.decodeFeatureConfiguration(FeatureFlag.RO_EPIC_DIRECT);
                if ((config === null || config === void 0 ? void 0 : config.debug) && response.results.length > 0) {
                    const debugEntries = response.results.map((r) => {
                        var _a, _b;
                        return ({
                            name: (_a = r.name) !== null && _a !== void 0 ? _a : "",
                            score: (_b = r.score) !== null && _b !== void 0 ? _b : null,
                            type: typeLabel(r),
                        });
                    });
                    console.log("[EpicSearchManager] search results (debug)", debugEntries);
                }
                return response;
            }
            catch (error) {
                console.error(error);
                return emptyResults();
            }
        }, 300);
    }
}
